import { ROUTE_NAME } from '@/router/meta'
import type { RouteRecordRaw } from 'vue-router'

export const analyticsRoute: RouteRecordRaw = {
  path: '/analytics',
  name: 'analytics',
  component: () => import('@/views/AnalyticsView.vue'),
  meta: {
    requiresAuth: true,
    showInMainNav: true,
    icon: '$chart-bar',
    [ROUTE_NAME]: 'analytics',
    new: true
  }
}

export const analyticsRoutes: RouteRecordRaw[] = [analyticsRoute]

export default analyticsRoutes
